var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useState, useContext } from 'react';
import useVisitProcessor from '@hooks/processors/use-visit-processor';
import { AssigneeType } from '@enums/assignee-type.enum';
import { VisitPriority } from '@enums/visit-priority.enum';
import apiClient from '@utils/api-client';
import { dateClient } from '@utils/date-client';
import { TimeZoneContext } from '@contexts/timezone-context';
import { apiInternalVisitPath } from '../../routes';
function useVisitPatch() {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState();
    const [result, setResult] = useState();
    const { processVisit } = useVisitProcessor();
    const { timeZonesMapping } = useContext(TimeZoneContext);
    const save = useCallback((visit) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        const controller = new AbortController();
        setSaving(true);
        const ianaTimeZone = (timeZonesMapping === null || timeZonesMapping === void 0 ? void 0 : timeZonesMapping[visit.timeZone]) || visit.timeZone;
        const patchData = {
            scheduledDate: dateClient(visit.start).tz(ianaTimeZone, true).toISOString(),
            visitStatus: visit.status.key,
            assigneeType: visit.assignee.type,
            technicianId: visit.assignee.type === AssigneeType.TECHNICIAN ? (_b = (_a = visit.assignee.info) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null : null,
            subcontractorId: visit.assignee.type === AssigneeType.SUBCONTRACTOR ? (_d = (_c = visit.assignee.info) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : null : null,
            duration: visit.durationMins,
            subcontractorBillingLimit: 'billingLimit' in visit ? visit.billingLimit : undefined,
            subcontractorPoNumber: 'poNumber' in visit ? visit.poNumber : undefined,
            visitNotes: visit.visitNotes,
            priority: visit.priority,
            priorityNote: visit.priority === VisitPriority.HIGH ? visit.priorityNote : null,
            timeZoneOverride: visit.timeZone
        };
        try {
            const response = yield apiClient.patch(apiInternalVisitPath(visit.id), undefined, {
                params: {
                    visit: patchData
                },
                signal: controller.signal
            });
            const patchResult = response.data.data;
            setResult(processVisit(patchResult));
        }
        catch (err) {
            if (!controller.signal.aborted) {
                setResult(undefined);
                setError(err);
            }
        }
        finally {
            if (!controller.signal.aborted)
                setSaving(false);
        }
    }), [processVisit, timeZonesMapping]);
    return { save, saving, error, result };
}
export default useVisitPatch;
